
<template>
    <div class="center examplex">
      <vs-table striped>
        <template #thead>
          <vs-tr>
            <vs-th width="50%">
              Alumno
            </vs-th>
            <vs-th width="50%">
              Datos fiscales
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in users"
            :data="tr"
            :style="users.length > 1 ? 'border-bottom: 1px solid #BDC3C7' : ''"
          >
            <vs-td>
                <md-chip class="mb-1 fontMedium mini-chip" :class="status_datos[tr.status_datos_fiscales]['color']" >
                    <p class="text-uppercase"><strong><span>{{ status_datos[tr.status_datos_fiscales]['text'] }}</span></strong></p>
                </md-chip> 
                <p class="mb-2 mt-3">No. Lista: <strong><span>{{ tr.no_lista }}</span></strong></p>
                <p class="mb-0"><small>NOMBRE</small></p>
                <p class="mb-2"><strong>{{ tr.nombre }}</strong></p>
                <p class="mb-0"><small>MATRICULA</small></p>
                <p class="mb-2"><strong>{{ tr.matricula }}</strong></p>
                <p class="mb-0"><small>GRUPO ADMINISTRATIVO</small></p>
                <p class="mb-2"><strong>{{ tr.grupo_administrativo }}</strong></p>
            </vs-td>
            <vs-td>
                <vs-row>
                    <vs-col sm="12" lg="6" class="p-2">
                        <p class="mb-0 text-uppercase"><small>RFC</small></p>
                        <p class="mb-2" v-if="tr.datos_fiscales && tr.datos_fiscales.rfc"><strong>{{ tr.datos_fiscales.rfc }}</strong></p>
                        <p class="mb-2 sinInfo" v-else><strong>No hay información</strong></p>

                        <p class="mb-0 text-uppercase"><small>Razón social</small></p>
                        <p class="mb-2" v-if="tr.datos_fiscales && tr.datos_fiscales.razon_social"><strong>{{ tr.datos_fiscales.razon_social}}</strong></p>
                        <p class="mb-2 sinInfo" v-else><strong>No hay información</strong></p>

                        <p class="mb-0 text-uppercase"><small>Correo fiscal</small></p>
                        <p class="mb-2" v-if="tr.datos_fiscales && tr.datos_fiscales.correo_fiscal"><strong>{{ tr.datos_fiscales.correo_fiscal }}</strong></p>
                        <p class="mb-2 sinInfo" v-else><strong>No hay información</strong></p>

                        <p class="mb-0 text-uppercase"><small>Régimen Fiscal  </small></p>
                        <p v-if="tr.datos_fiscales && tr.datos_fiscales.regimen_fiscal">
                            <span class="mb-2" v-for="option in regimenes" :key="option.id" ><strong>{{ option.id == tr.datos_fiscales.regimen_fiscal ? option.text : ''}}</strong></span>
                        </p>
                        <p class="mb-2 sinInfo" v-else><strong>No hay información</strong></p>
                    </vs-col>
                    <vs-col sm="12" lg="6" class="p-2">
                        <p class="mb-0 text-uppercase"><small>C.P.</small></p>
                        <p class="mb-2" v-if="tr.datos_fiscales && tr.datos_fiscales.codigo_postal"><strong>{{ tr.datos_fiscales.codigo_postal }}</strong></p>
                        <p class="mb-2 sinInfo" v-else><strong>No hay información</strong></p>

                        <p class="mb-0 text-uppercase"><small>Uso de CFDI</small></p>
                        <p v-if="tr.datos_fiscales && tr.datos_fiscales.uso_cfdi">
                            <span class="mb-2" v-for="option in optCfdi" :key="option.id" ><strong>{{option.id == tr.datos_fiscales.uso_cfdi ? option.text : '' }}</strong></span>
                        </p>
                        <p class="mb-2 sinInfo" v-else><strong>No hay información</strong></p>

                        <p class="mb-0 text-uppercase"><small>Facturación automática</small></p>
                        <p class="mb-2" v-if="tr.datos_fiscales && tr.datos_fiscales.facturacion_automatica && tr.datos_fiscales.facturacion_automatica == '1'"><strong>Si</strong></p> 
                        <p class="mb-2" v-else><strong>No</strong></p> 
                    </vs-col>
                </vs-row>
            </vs-td>
          </vs-tr>
        </template>
        <template #notFound>
            No hay información
        </template>
      </vs-table>
    </div>
</template>
<script>
import landing from '../../../../api/requests/landing.js'
    export default {
        props:[
            'users'
        ],
        data:() => ({
            optCfdi:[
                {'id': 'G01', 'text': 'Adquisición de Mercancías'},
                {'id': 'G02', 'text': 'Devoluciones, Descuentos o Bonificaciones'},
                {'id': 'G03', 'text': 'Gastos en General'},
                {'id': 'I01', 'text': 'Construcciones'},
                {'id': 'I02', 'text': 'Mobiliario y Equipo de Oficina por Inversiones'},
                {'id': 'I03', 'text': 'Equipo de Transporte'},
                {'id': 'I04', 'text': 'Equipo de Cómputo y Accesorios'},
                {'id': 'I05', 'text': 'Dados, Troqueles, Moldes, Matrices y Herramental'},
                {'id': 'I06', 'text': 'Comunicaciones Telefónicas'},
                {'id': 'I07', 'text': 'Comunicaciones Satelitales'},
                {'id': 'I08', 'text': 'Otra Maquinaria y Equipo'},
                {'id': 'D01', 'text': 'Honorarios Médicos, Dentales y Gastos Hospitalarios'},
                {'id': 'D02', 'text': 'Gastos Médicos por Incapacidad o Discapacidad'},
                {'id': 'D03', 'text': 'Gastos Funerales'},
                {'id': 'D04', 'text': 'Donativos'},
                {'id': 'D05', 'text': 'Intereses Reales Efectivamente Pagados por Créditos Hipotecarios (Casa Habitación)'},
                {'id': 'D06', 'text': 'Aportaciones Voluntarias al SAR'},
                {'id': 'D07', 'text': 'Primas por Seguros de Gastos Médicos'},
                {'id': 'D08', 'text': 'Gastos de Transportación Escolar Obligatoria'},
                {'id': 'D09', 'text': 'Depósitos en Cuentas para el Ahorro, Primas que tengan como Base Planes de Pensiones'},
                {'id': 'D10', 'text': 'Pagos por Servicios Educativos (Colegiaturas)'},
                {'id': 'P01', 'text': 'Por Definir'}
            ],
            regimenes: [],
            status_datos:{
                'facturacion_generica':{
                    'color': 'col-yellow',
                    'text': 'Facturación genérica'
                },
                'datos_incompletos_cfdi4':{
                    'color': 'col-red',
                    'text': 'Datos incompletos'
                },
                'datos_completos_cfdi4':{
                    'color': 'col-green',
                    'text': 'Datos completos'
                }
            }
        }),
        created(){
            this.getRegimen()
        },
        methods:{
            async getRegimen(){
                try {
                    const response = await landing.getRegimen()
                    this.regimenes = response.data
                } catch (error) {

                }
            },
        }

    }
</script>

<style scoped>
    .sinInfo{
        color: #7B241C;
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #b6940b;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }
</style>
        